import { apiPost } from '../api';

// Backend-compatible payload (matches ContactFormSchema in backend/src/schemas/index.ts)
export interface ContactFormPayload {
  name: string;
  email: string;
  subject?: string;  // Maps from frontend 'reason' field
  message: string;
  turnstile_token?: string;  // Snake case to match backend
}

export interface ContactResponse {
  ok: boolean;
}

export const contactApi = {
  submitMessage: (data: ContactFormPayload): Promise<ContactResponse> =>
    apiPost('/contact', data),
};